import { IntlShape } from "react-intl";

import { TableRowProps } from "@nens/ranalib";

export const findDisabledFileHistoryReason = (message: string) => {
  if (message.startsWith("Deleted ")) return "deleted";
  if (message.startsWith("Moved ")) return "moved";
  if (message.startsWith("Renamed ")) return "renamed";
  return null;
};

export const disabledFileHistoryProps = (
  intl: IntlShape,
  message: string
): Partial<TableRowProps> => {
  const reason = findDisabledFileHistoryReason(message);
  if (reason === "deleted")
    return {
      isDisabled: true,
      title: intl.formatMessage({
        id: "message.file_version_deleted",
        defaultMessage: "File got deleted in this version",
      }),
    };

  if (reason === "moved")
    return {
      isDisabled: true,
      title: intl.formatMessage({
        id: "message.file_version_moved",
        defaultMessage: "File got moved in this version",
      }),
    };

  if (reason === "renamed")
    return {
      isDisabled: true,
      title: intl.formatMessage({
        id: "message.file_version_renamed",
        defaultMessage: "File got renamed in this version",
      }),
    };

  return {};
};
